<template>
  <div v-if="selectedDriver">
    <div class="modal fade" role="dialog" ref="driverdocumentmodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Driver Document ({{ selectedDriver.fullName }})</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                        <!-- Start: Form -->
                        <div class="col-sm-3 divider-right pr-25">
                          <div class="summary-error" v-if="$v.model.$error">
                            This form has errors
                          </div>
                          <form @submit.prevent="submit">
                            <div class="form-group">
                              <label class="required">Name</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error': isSubmitted && $v.model.name.$error,
                                }"
                                type="text"
                                v-model="model.name"
                                :disabled="isViewOnly"
                                autocomplete="off"
                              />
                              <div v-if="isSubmitted && $v.model.name.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.required"
                                  >Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.maxLength"
                                  >Name must be less than
                                  {{ $v.model.name.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                            <div
                              class="mb-15"
                              v-if="
                                !isUpdate &&
                                !isViewOnly &&
                                (isAllowToCreate || isAllowToUpdate)
                              "
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <input
                                id="driver-document-uploader"
                                class="custom-file-input input-uploader"
                                type="file"
                                accept="image/jpeg,image/png,application/pdf,application/vnd.ms-excel"
                                name="document"
                                v-on:change="onChangeDocument($event.target.files)"
                                required
                              />
                            </div>
                            <div
                              class="modal-footer"
                              v-if="!isViewOnly && (isAllowToCreate || isAllowToUpdate)"
                            >
                              <button
                                v-if="isAllowToCreate || isAllowToUpdate"
                                type="button"
                                class="btn btn-default"
                                @click.prevent="reset()"
                              >
                                Reset
                              </button>
                              <button
                                v-if="!isUpdate && isAllowToCreate"
                                type="submit"
                                class="btn btn-primary"
                              >
                                Create
                              </button>
                              <button
                                v-if="isUpdate && isAllowToUpdate"
                                type="submit"
                                class="btn btn-primary"
                              >
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                        <!-- End: Form -->
                        <!-- Start: Table -->
                        <div class="col-sm-9 divider-left pl-20">
                          <div class="table-modal-detail">
                            <div class="table-responsive">
                              <table class="table table-hover table-fix mtz">
                                <thead>
                                  <tr>
                                    <th class="number">No</th>
                                    <th>Name</th>
                                    <th>Size</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center" v-if="!isViewOnly">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in items" :key="item.id">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ printFileSize(item.size) }}</td>
                                    <td class="text-center">
                                      <label class="cursor-pointer">
                                        <input
                                          type="checkbox"
                                          class="control-checkbox"
                                          v-model="item.isActive"
                                          :disabled="isViewOnly || !isAllowToUpdate"
                                          @change="changeStatus(item)"
                                        />
                                        <span class="pl-5 font-weight-normal v-align-middle">
                                          {{ item.isActive ? "Active" : "Inactive" }}
                                        </span>
                                      </label>
                                    </td>
                                    <td class="text-center" v-if="!isViewOnly">
                                      <div class="button-action-wrapper">
                                        <button
                                          v-if="isAllowToUpdate"
                                          class="btn btn-default"
                                          type="button"
                                          @click="bindModel(item)"
                                        >
                                          <span>Edit</span>
                                        </button>
                                        <button
                                          v-if="isAllowToDelete"
                                          class="btn btn-default"
                                          type="button"
                                          @click="confirmDelete(item)"
                                        >
                                          <i class="ic-close"></i>
                                        </button>
                                        <button
                                          class="btn btn-default --green35"
                                          type="button"
                                          @click="viewDocument(item.id)"
                                        >
                                          <span>View</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- End: Table -->
                      </div>
                      <!-- /.row -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import driverDocumentService from "@/services/master/driver/driverDocumentService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedDriver: null,
      document: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        name: { required, maxLength: maxLength(100) },
      },
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeDriverDocument", this.initialize);
    this.$eventBus.$on("deleteDriverDocument", this.deleteItem);
    this.$eventBus.$on("openModalDriverDocument", this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeDriverDocument");
    this.$eventBus.$off("deleteDriverDocument");
    this.$eventBus.$off("openModalDriverDocument");
    this.closeModal();
  },
  methods: {
    openModal() {
      $(this.$refs.driverdocumentmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.driverdocumentmodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.driverdocumentmodal).modal("hide");
    },
    async initialize(driver) {
      try {
        this.isViewOnly = !driver.isOwnInventory;
        this.isLoading = true;
        this.reset();
        this.selectedDriver = driver;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["DriverDocument"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          await this.getAll();
        }
        this.openModal();
        const uploader = document.getElementById("driver-document-uploader");
        if (uploader) {
          uploader.value = "";
        }
      } finally {
        this.isLoading = false;
      }
    },
    bindModel(object) {
      const uploader = document.getElementById("driver-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = true;
      this.document = null;
      this.resetValidations();
      this.model = Object.assign({}, object);
    },
    reset() {
      const uploader = document.getElementById("driver-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = false;
      this.document = null;
      this.resetValidations();
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    async getAll() {
      this.items = await driverDocumentService.getAll(this.selectedDriver.id);
    },
    onChangeDocument(files) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.document = null;
        document.getElementById("driver-document-uploader").value = "";
        alert(`File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`);
        return;
      }
      const fileExt = files[0].name
        .substring(files[0].name.lastIndexOf(".") + 1)
        .toLowerCase();
      if (!["jpeg", "jpg", "png", "pdf"].includes(fileExt)) {
        this.document = null;
        document.getElementById("driver-document-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.document = files[0];
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.driverId = this.selectedDriver.id;
        if (!this.isUpdate) {
          const formData = new FormData();
          for (const key in this.model) {
            if (this.model.hasOwnProperty(key)) {
              formData.append(key, this.model[key]);
            }
          }
          formData.append(this.document.name, this.document);
          await driverDocumentService.create(formData);
          this.$notification.success("Successfully added.", { title: "Success" });
        } else {
          await driverDocumentService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        }
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.driverId = this.selectedDriver.id;
        await driverDocumentService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.closeModal();
      // publish message
      this.$eventBus.$emit("openDriverDeleteModal", "driverDocument", item.id);
    },
    async deleteItem(id) {
      try {
        this.isLoading = true;
        await driverDocumentService.delete(id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.openModal();
        this.isLoading = false;
      }
    },
    async viewDocument(id) {
      try {
        this.isLoading = true;
        const response = await driverDocumentService.view(id);
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printFileSize(size) {
      return this.$helper.printFileSize(size);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/driver/DriverDocument.vue